import { useEffect, useState } from 'react'

import moment from 'moment'
import Image from 'next/image'
import { twMerge } from 'tailwind-merge'

import { shouldShowSummit, SUMMIT_EVENT_DATE } from 'utils/summit'

const SUMMIT_LINK =
	'https://www.sympla.com.br/evento/vittude-summit-2026/2845683?utm_source=website&utm_medium=banner'

const SUMMIT_COUPOM = 'VITTUDE'
const SUMMIT_COUPOM_VALUE = '15%'

const formatTwoDigits = (n) =>
	String(Math.max(0, Math.floor(n))).padStart(2, '0')

const COUNTDOWN_ITEM = ({ value, label }) => (
	<div className='flex flex-col items-center'>
		<div className='flex h-[70px] min-w-[48px] flex-col items-center justify-center rounded-md bg-gray-100 px-2 py-1.5 md:min-w-[58px] md:px-2.5 md:py-2'>
			<span className='text-[40px] text-lg font-bold tabular-nums text-white md:text-2xl'>
				{value}
			</span>
		</div>
		<span className='mt-1 text-[7px] font-semibold uppercase tracking-wide text-white md:text-[10px]'>
			{label}
		</span>
	</div>
)

export const SummitCountdown = () => {
	const [timeLeft, setTimeLeft] = useState(null)

	useEffect(() => {
		const tick = () => {
			const now = new Date()
			const diff = SUMMIT_EVENT_DATE - now
			if (diff <= 0) {
				setTimeLeft({ days: 0, hours: 0, mins: 0, secs: 0 })
				return
			}
			const remaining = moment.duration(diff)
			setTimeLeft({
				// `days()` é o resto depois de extrair anos e meses (366 dias → 0)
				days: Math.floor(remaining.asDays()),
				hours: remaining.hours(),
				mins: remaining.minutes(),
				secs: remaining.seconds()
			})
		}
		tick()
		const id = setInterval(tick, moment.duration(1, 'second').asMilliseconds())
		return () => clearInterval(id)
	}, [])

	if (timeLeft === null || !shouldShowSummit()) return null

	const { days, hours, mins, secs } = timeLeft

	return (
		<div id='summit-countdown' className='summit-countdown-bg w-full'>
			<div
				className={twMerge(
					'mx-auto flex w-full max-w-[1200px] flex-col',
					'md:min-h-[80px] md:flex-row'
				)}
			>
				<div
					className={twMerge(
						'flex flex-[0_0_100%] flex-col items-center justify-center px-4 py-3',
						'md:flex-[0_0_33%] md:items-start md:px-6'
					)}
				>
					<p className='mb-2 text-center !text-[14px] font-semibold uppercase text-[#ffa8a8] sm:text-white md:mb-3 md:text-left md:text-xs xl:text-[#FF6E6E]'>
						O MAIOR EVENTO DE
					</p>
					<p className='text-center font-fjalla !text-[30px] font-bold uppercase !leading-[2rem] md:text-left md:text-base'>
						<span className='block text-gray-800'>SAÚDE MENTAL</span>
						<span className='block text-gray-800'>CORPORATIVA</span>
						<span className='block text-gray-800'>DO BRASIL</span>
					</p>
				</div>
				{/* Painel direito: countdown no centro, botão fixo à direita */}
				<div
					className={twMerge(
						'relative flex flex-1 flex-col items-center justify-center gap-2 px-4 py-3',
						'md:flex-row md:px-6 md:pr-32'
					)}
				>
					{/* Countdown centralizado com gap à direita */}
					<div className='items-left justify-left flex min-w-0 flex-1'>
						<div className='flex shrink-0 items-center gap-2 md:mr-8 md:gap-5'>
							<COUNTDOWN_ITEM value={formatTwoDigits(days)} label='DIAS' />
							<COUNTDOWN_ITEM value={formatTwoDigits(hours)} label='HORAS' />
							<COUNTDOWN_ITEM value={formatTwoDigits(mins)} label='MINUTOS' />
							<COUNTDOWN_ITEM value={formatTwoDigits(secs)} label='SEGUNDOS' />
						</div>
					</div>

					<div className='flex min-w-0 flex-1 gap-4'>
						<div className='-ml-[12%] flex min-w-0 flex-1 items-center justify-center md:justify-start'>
							<div>
								<p className='mb-2 text-center !text-[14px] font-semibold uppercase text-white md:mb-3 md:text-left md:text-xs md:text-white'>
									USE O CUPOM &quot;{SUMMIT_COUPOM}&quot;
								</p>
								<p className='text-center font-fjalla !text-[30px] font-bold uppercase !leading-[2rem] md:text-left md:text-base'>
									<span className='block text-gray-800'>
										E GANHE {SUMMIT_COUPOM_VALUE} OFF
									</span>
								</p>
							</div>
						</div>
						<div className='flex min-w-0 flex-1 flex-col items-center justify-center gap-2 md:items-end'>
							<Image
								src='/static/images/summit/logo-vittude-summit.png'
								alt='Vittude Summit'
								width={185}
								height={20}
								className='w-[185px] object-contain md:h-10'
							/>
							<a
								href={SUMMIT_LINK}
								target='_blank'
								rel='noopener noreferrer'
								className={twMerge(
									'rounded bg-gray-100 px-4 py-2 text-center text-sm font-bold uppercase text-white',
									'transition hover:bg-gray-800'
								)}
							>
								Compre agora
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
